import { IProductDataV3, Product } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { NgInject } from '@df/ng/ng-inject';
import { BasketItem, basketItemFactory, IBasketItemCustomOption } from '@df/session/api/basket/basket-item';
import {
    MOUNTING_ATTRIBUTE_ID,
    Z_CLIP_ORIENTATION_CUSTOM_OPTION_TITLE,
    Z_CLIPS_OPTION_LABEL
} from '../catalog/product/view/configurable-options/product-view-configurable-options.component';

export class BasketItemDecorator extends BasketItem<Product<IProductDataV3>> {
    private _childrenProduct: Product<IProductDataV3> | undefined;;

    @NgInject(App)
    private appInstance!: App;

    override get product(): Product<IProductDataV3> | undefined {
        const product = super.product;

        if (product?.isConfigurable && this.childrenProduct) {
            return this.childrenProduct;
        }

        return product;
    }

    private get childrenProduct(): Product<IProductDataV3> | undefined {
        if (!this._childrenProduct) {
            const childrenId = this.data?.children?.[0]?.product;
            if (childrenId) {
                const product = this.productResource.getExisting(childrenId) as Product<IProductDataV3>;
                if (product?.isSimple) {
                    this._childrenProduct = product;
                }
            }
        }
        return this._childrenProduct;
    }

    /**
     * Override customOptions to filter out Z-Clip Orientation
     * when Z-Clips mounting is not selected
     */
    override get customOptions(): IBasketItemCustomOption[] | undefined {
        const options = super.customOptions;

        if (!options?.length) {
            return options;
        }

        if (!this.isZClipsMountingSelected) {
            return options.filter(
                option => option.title?.toLowerCase() !== Z_CLIP_ORIENTATION_CUSTOM_OPTION_TITLE
            );
        }

        return options;
    }

    /**
     * Determines if Z-Clips is selected as the mounting hardware
     */
    private get isZClipsMountingSelected(): boolean {
        const mountingOption = this.configurableOptions?.find(opt => opt.code === MOUNTING_ATTRIBUTE_ID);
        if (!mountingOption) {
            return false;
        }

        const mountingAttribute = this.appInstance.resources.attribute.getExisting(MOUNTING_ATTRIBUTE_ID);
        if (!mountingAttribute?.data?.options?.length) {
            return false;
        }

        const zClipsOption = mountingAttribute.data.options.find(
            opt => opt.label?.toString()?.toLowerCase() === Z_CLIPS_OPTION_LABEL
        );

        return zClipsOption?.value === mountingOption.value;
    }
}

basketItemFactory.instance = BasketItemDecorator;
